<template>
  <div id="app">
    <!-- 顶部导航栏 -->
    <el-header class="header">
      <div class="nav-container">
        <div class="logo">
          <img src="@/assets/logo.png" alt="锐扬智联">
          <span>锐扬智联</span>
        </div>
        <el-menu
          mode="horizontal"
          :router="true"
          :default-active="activeIndex"
          class="nav-menu"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>
          <el-menu-item index="/products">产品服务</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- 主要内容区 -->
    <main>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>

    <!-- 页脚 -->
    <el-footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>联系方式</h3>
          <p>电话：13891879639</p>
          <p>邮箱：narrater_2000@qq.com</p>
          <p>地址：陕西省咸阳市兴平市东城街道办中心大街中段东侧鑫福世纪城东区项目商业103号</p>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <router-link to="/">首页</router-link>
          <router-link to="/about">关于我们</router-link>
          <router-link to="/products">产品服务</router-link>
        </div>
        <div class="footer-section">
         <!-- <h3>关注我们</h3>
          <p>微信公众号：锐扬智联</p>
          <p>企业微博：@锐扬智联</p>-->
        </div>
      </div>
      <div class="footer-bottom">
        <p>© 2025 陕西锐扬智联网络科技有限公司 版权所有</p>
        <p>陕ICP备2025065891号</p>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    activeIndex() {
      return this.$route.path
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.header {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  background: white;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 40px;
  margin-right: 10px;
}

.logo span {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.nav-menu {
  border-bottom: none;
}

main {
  margin-top: 60px;
  flex: 1;
}

.footer {
  background-color: #2c3e50;
  color: white;
  padding: 40px 0 20px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  padding: 0 20px;
}

.footer-section h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-section p {
  margin: 10px 0;
  color: #ddd;
}

.footer-section a {
  display: block;
  color: #ddd;
  text-decoration: none;
  margin: 10px 0;
}

.footer-section a:hover {
  color: white;
}

.footer-bottom {
  max-width: 1200px;
  margin: 40px auto 0;
  padding: 20px;
  text-align: center;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.footer-bottom p {
  margin: 5px 0;
  color: #ddd;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 768px) {
  .nav-container {
    padding: 0 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}
</style>

